import { Box, Card, CardContent, CardMedia, IconButton, Link } from '@mui/material';
import { Theme, alpha } from '@mui/material/styles';
import { getCountryFlag } from '@raas/shared/src/components/country-flag-dropdown/CountryFlagDropdown';
import Iconify from '@raas/shared/src/components/minimals/iconify';
import TextMaxLine from '@raas/shared/src/components/minimals/text-max-line';
import LegalProvisionContext from '@raas/shared/src/contexts/LegalProvisionContext';
import { useLocales } from '@raas/shared/src/locales';
import { PATH_DASHBOARD } from '@raas/shared/src/routes/paths';
import { NAV } from '@raas/shared/src/shared-config-global';
import { IReadLegalProvision } from '@raas/shared/src/types/legal-provision';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

type props = {
  current: IReadLegalProvision | undefined;
  theme: Theme;
};

export const NavCardItem = ({ current, theme }: props) => {
  const { translate } = useLocales();
  const { clearLegalProvisionContext, legalProvisionContext } = useContext(LegalProvisionContext);
  const navigate = useNavigate();

  const handleReset = () => {
    clearLegalProvisionContext();
    navigate(PATH_DASHBOARD.overview.root);
  };

  return (
    <Link
      href={legalProvisionContext ? `${PATH_DASHBOARD.regulation.root}/${current?.id}/content` : ''}
    >
      <Card
        sx={{
          display: 'flex',
          width: NAV.W_DASHBOARD,
          height: 61,
          borderRadius: 0,
          backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        }}
      >
        {current?.abbreviation && (
          <CardMedia
            component="div"
            sx={{
              width: 90,
              objectPosition: 'center',
              clipPath: 'polygon(0 0, 100% 0, 80% 100%, 0 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {getCountryFlag(current?.countryFlag, { height: '100' })}
          </CardMedia>
        )}

        <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
          <CardContent
            sx={{
              flex: '1 0 auto',
              padding: 0,
              pl: 1,
              width: 'fit-content',
              flexDirection: 'row',
              alignSelf: 'center',
              '&:last-child': { pb: 0 },
            }}
          >
            {current && (
              <>
                <TextMaxLine
                  line={2}
                  sx={{ fontWeight: 'bold', maxWidth: '175px' }}
                  variant="body2"
                >
                  {current.abbreviation}
                </TextMaxLine>
                <TextMaxLine line={1} color="text.secondary" variant="caption">
                  {`${translate('landingPage.legislationItems.version')} ${current.versionName}`}
                </TextMaxLine>
              </>
            )}
          </CardContent>
        </Box>
        <IconButton
          aria-label="delete"
          sx={{ position: 'absolute', right: 0, top: 0 }}
          onClick={handleReset}
        >
          <Iconify icon="eva:close-fill" />
        </IconButton>
      </Card>
    </Link>
  );
};
